export default "__VITE_ASSET__CamBsUKy__"